import { useShowCart } from '@givebacks/api/store';
import { Modal, ModalProps, Stack, Title } from 'ui';

import { Printty } from '../../../../../packages/Printty/printty';
import { Order } from '../../Order/Order';
import { FullOrderModalProps } from './FullOrderModal.types';
import { FullOrderModalFooter } from './FullOrderModalFooter';

type FullOrderModalContentProps = {
  orderUuid: string;
  causeId: string;
  printRef: React.RefObject<HTMLDivElement>;
  onOpenNewOrderNoteModal?: () => void;
};

const FullOrderModalContent = ({
  orderUuid,
  causeId,
  printRef,
  onOpenNewOrderNoteModal,
}: FullOrderModalContentProps) => {
  const { data: order } = useShowCart({ cartId: orderUuid, causeId, queryKeyId: causeId });

  return order ? (
    <Order order={order} onOpenNewOrderNoteModal={onOpenNewOrderNoteModal} printRef={printRef} />
  ) : null;
};

const FullOrderModal = ({
  order,
  onResendReceipt,
  onRefund,
  onCancelPledge,
  onOpenNewOrderNoteModal,
  posOrderActions,
  ...rest
}: FullOrderModalProps & ModalProps) => {
  const { targetRef: printRef, print: onPrint } = Printty.usePrint({
    HeaderElement: (
      <Stack>
        <Title order={2}>Order {order.uuid} </Title>
      </Stack>
    ),
  });

  return (
    <Modal
      title={`Order #${order.uuid}`}
      size="lg"
      styles={{
        header: {
          paddingBottom: 0,
        },
        body: {
          padding: 0,
        },
      }}
      {...rest}
    >
      <FullOrderModalContent
        orderUuid={order.uuid}
        causeId={order.cause_id}
        printRef={printRef}
        onOpenNewOrderNoteModal={onOpenNewOrderNoteModal}
      />
      <FullOrderModalFooter
        onResendReceipt={onResendReceipt}
        onPrint={onPrint}
        onRefund={onRefund}
        onCancelPledge={onCancelPledge}
        posOrderActions={posOrderActions}
      />
    </Modal>
  );
};

export { FullOrderModal };
